// NoResponsePage.js
import React from 'react';
import './NoResponsePage.css';

const TimeOut = () => {
  return (
    <div className="no-response-container">
      <div className="message-box">
        <h2 className="title">You do not have access to this page</h2>
        <p className="message">No CSV Content Available.</p>
      </div>
    </div>
  );
};

export default TimeOut;
